import { history } from 'instantsearch.js/es/lib/routers'
import { searchTypes } from './refinement-list'

export default function Routing({ indexName }) {
  return {
    router: history({
      
      createURL({ routeState }) {
        const params = new URLSearchParams()
        if (routeState.query) params.append('q', routeState.query as string)
        if (routeState.type) params.append('type', routeState.type as string)

        const queryString = `${params.toString()?.length > 0 ? '?' : ''}${params.toString()}`

        // algolia!  this is junk!
        // https://github.com/algolia/react-instantsearch/issues/3506
        // if (!queryString) window.history.pushState({}, '', queryString)

        return queryString
      },

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      parseURL({ location }) {
        const params = new URLSearchParams(location.search)
        return {
          query: params.get('q') || '',
          type: params.get('type') || '',
        }
      },

      writeDelay: 10,
    }),

    stateMapping: {
      stateToRoute(uiState) {
        return {
          query: uiState[indexName].query,
          type: uiState[indexName].refinementList?.type?.filter((type) => searchTypes.includes(type))?.[0] || '',
        }
      },

      routeToState(routeState) {
        return {
          [indexName]: {
            query: routeState.query,
            refinementList: {
              type: [routeState.type],
            },
          },
        }
      },
    },
  }
}
